/**
 * StyleCard — Brand style proposal card with color preview, fonts, and selection.
 */
import ColorPalette from './ColorPalette.jsx';
import FontPreview from './FontPreview.jsx';

export default function StyleCard({ proposal, index, selected, onToggle, onSelect }) {
  // Build a mini preview swatch using the brand colors
  const bg = proposal.colors?.background || '#fff';
  const primary = proposal.colors?.primary || '#3B82F6';
  const text = proposal.colors?.text || '#1F2937';
  const accent = proposal.colors?.accent || '#F59E0B';

  return (
    <div className={`border-2 rounded-xl overflow-hidden transition-all ${selected ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-gray-300 hover:shadow-md'}`}>
      {/* Color preview banner */}
      <div className="h-20 relative" style={{ backgroundColor: bg }}>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-lg font-bold" style={{ color: primary, fontFamily: `'${proposal.font_heading}', sans-serif` }}>
            {proposal.concept_name || `Option ${index + 1}`}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <input type="checkbox" checked={selected} onChange={() => onToggle(index)} className="w-4 h-4 text-blue-600 rounded" />
        </div>
        {/* Accent bar */}
        <div className="absolute bottom-0 left-0 right-0 h-1" style={{ backgroundColor: accent }} />
      </div>

      <div className="p-3">
        <p className="text-xs text-gray-500 mb-3 line-clamp-2 min-h-[2rem]">{proposal.mood}</p>
        <ColorPalette colors={proposal.colors} />
        <div className="mt-3 border-t border-gray-100 pt-2">
          <FontPreview heading={proposal.font_heading} body={proposal.font_body} />
        </div>
        <button onClick={(e) => { e.stopPropagation(); onSelect(index); }} className="mt-3 w-full text-xs py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-700 font-medium">
          Use This Style
        </button>
      </div>
    </div>
  );
}
